module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (53).f170e47d.jpg";